import React from "react";
import {Col, Container, Image, Row} from "react-bootstrap";

function Footer() {
    /**
     * SPoRT footer to go at the bottom of the main page.
     * @param : None
     * @returns: footer JSX component with NASA logo, technical contacts, support/disclaimer links, and link to SPoRT Twitter
     */

    return (
        <Container fluid="md" className="text-center mt-3 pb-1 px-0 px-xl-2 border border-dark my-0 py-2 my-md-3 rounded" style={{ backgroundColor: "#092743", color:"white"}}>
            <Row className="row align-items-center">
                <Col className="col-3">
                    <Image src="https://weather.ndc.nasa.gov/images/nasalogohq-110x92.png" style={{ height: "55px" }} className="mx-auto"/>
                </Col>
                <Col className="col-6" style={{ fontSize: "0.8rem"}}>
                    Technical Contact: Dr. Emily Berndt (emily.b.berndt@nasa.gov)<br/>
                    Responsible Official: Dr. Andrew Molthan (andrew.molthan@nasa.gov)<br/>
                    Page Curator: SPoRT Support (msfc-dl-sport-support@mail.nasa.gov)<br/>
                    <a href="mailto:msfc-dl-sport-support@mail.nasa.gov">Support</a>
                    &nbsp;&nbsp;&nbsp;
                    <a href="/disclaimer.html">Disclaimer</a>
                </Col>
                <Col className="col-3">
                </Col>
          </Row>
        </Container>
    );

}

export default Footer;
